import { FC, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';

import clsx from 'clsx';

import {
	actionGetEmployeesFiltersLogin,
	actionGetEmployeesFiltersRoles,
	actionGetEmployeesList,
	actionGetRoles,
} from '../../../redux/action/accessRights/actionUsersList';

import {
	reducerClientsInputValues,
	reducerSelectedUserId,
	reducerClientsStatus,
	reducerSelectedUser,
} from '../../../redux/reducer/accessRights/reducers/usersList';
import { generateStyles } from '../../../utils/generateToastStyles';
import { AppDispatch } from '../../../redux/reducer/store';

import { formatReports } from '../../../utils/formatReports';

import Select from '../../custom/select/select';
import LimitSelect from '../../custom/limitSelect/limitSelect';
import ToastPopup from '../../custom/toastPopup/toastPopup';
import Pagination from '../../pagination/pagination';
import RolesEmployeesModal from "../../rolesModal/rolesEmployeesModal";
import Loader from '../../custom/loader/loader';

import '../table.scss';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const requestStatusOptions = [
	{
		status: 200,
		successMessage: 'Новый клиент успешно добавлен!',
	},
	{
		status: 0,
		errorMessage: 'При добавлении клиента произошла ошибка!',
	},
	{
		status: 'deleteSuccess',
		successMessage: 'Клиент успешно удален!',
	},
	{
		status: 'deleteError',
		errorMessage: 'При удалении клиента произошла ошибка!',
	},
	{
		status: 'invalidEmail',
		errorMessage: 'Некорректный адрес электронной почты!',
	},
	{
		status: 'noData',
		errorMessage: 'Необходимо заполнить недостающие значения!',
	},
	{
		status: 'updateSuccess',
		successMessage: 'Данные клиента успешно обновлены!',
	},
	{
		status: 'updateError',
		errorMessage: 'При обновлении данных клиента произошла ошибка!',
	},
];

const booleanOptions = [
	{ value: 'all', label: 'Все' },
	{ value: 'yes', label: 'Да' },
	{ value: 'no', label: 'Нет' },
];

const TableAdminUsers: FC = () => {
	const dispatch = useDispatch<AppDispatch>();

	const {
		userInputValues,
		selectedUserId,
		clientsStatus,
		usersFilters,
		checkboxes,
		usersCount,
		limit,
		pages,
		data,
	} = useSelector((state: any) => state.roles.usersList);
	const { isOpenSidebar } = useSelector((state: any) => state.user.user);
	//const { claims } = useSelector((state: any) => state.user.user.data);
	const [isInputChange, setIsInputChange] = useState<boolean>(false);
	const [isPending, setIsPending] = useState<boolean>(false);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [roleClaims, setRoleClaims] = useState<any>();
  const [modalTitle, setModalTitle] = useState<string>("");
  const [roleId, setRoleId] = useState<number>();
	const [currentPage, setCurrentPage] = useState(1);
	const [startPage, setStartPage] = useState(1);
	const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] =
		useState<boolean>(false);
	const [isCheckedRows, setIsCheckedRows] = useState<any>(checkboxes);

	const actualLimit =
		JSON.parse(localStorage.getItem('pageLimit') as string) || limit;
		
	const optionsRoles = usersFilters?.roles ? [...usersFilters.roles] : [];
	const optionsLogins = usersFilters?.logins ? [...usersFilters.logins] : [];
	optionsRoles.unshift({label: 'Все', value: ''});
	optionsLogins.unshift({label: 'Все', value: ''})

	useEffect(() => {
		requestStatusOptions.forEach((option: any) => {
			if (clientsStatus === option.status) {
				toast.dismiss();

				toast(
					t => (
						<ToastPopup
							title={
								option.successMessage
									? option.successMessage
									: option.errorMessage
							}
							isSuccess={option.successMessage ? true : false}
							toast={toast}
							t={t}
						/>
					),
					generateStyles(option.successMessage ? true : false)
				);
			}
		});

		dispatch(reducerClientsStatus(null));
	}, [dispatch, clientsStatus]);

	useEffect(() => {
		if (selectedUserId && !selectedUserId.length) {
			setIsCheckedRows(data && checkboxes);
			setIsHeaderCheckboxChecked(false);
		}
		// eslint-disable-next-line
	}, [checkboxes, data, selectedUserId]);

	useEffect(() => {
		if (data) {
			const updatedCheckedRows =
			data &&
			data.reduce((acc: any, user: any) => {
					const userId = user.id;
					acc[userId] = false;
					return acc;
				}, {});
			dispatch(reducerSelectedUserId(formatReports(updatedCheckedRows)));
			setIsCheckedRows(updatedCheckedRows);
		}
	// eslint-disable-next-line
	}, [dispatch, data]);

	useEffect(() => {
		if (isHeaderCheckboxChecked && data) {
			const updatedCheckedRows =
			data &&
			data.reduce((acc: any, user: any) => {
					const userId = user?.id;
					acc[userId] = isHeaderCheckboxChecked ? true : false;
					return acc;
				}, {});
			dispatch(reducerSelectedUserId(formatReports(updatedCheckedRows)));
			setIsCheckedRows(updatedCheckedRows);
		}
		// eslint-disable-next-line
	}, [dispatch, isHeaderCheckboxChecked, data]);

	const handleHeaderCheckboxChange = () => {
		setIsHeaderCheckboxChecked(!isHeaderCheckboxChecked);
		if (isHeaderCheckboxChecked) {
			const updatedCheckedRows =
			data &&
			data.reduce((acc: any, user: any) => {
					const userId = user?.id;
					acc[userId] = false;
					return acc;
				}, {});
			dispatch(reducerSelectedUserId(formatReports(updatedCheckedRows)));
			setIsCheckedRows(updatedCheckedRows);
		}
	};
	const handleRowCheckboxChange = (el: any) => {
		const userId = el.id;
		setIsCheckedRows((prevCheckedRows: any) => ({
			...prevCheckedRows,
			[userId]: !prevCheckedRows[userId],
		}));
		const updatedSelectedVacancies = formatReports({
			...isCheckedRows,
			[userId]: !isCheckedRows[userId],
		});
		dispatch(reducerSelectedUserId(updatedSelectedVacancies));
		dispatch(reducerSelectedUser(el));
		if (updatedSelectedVacancies.length === data.length) {
			setIsHeaderCheckboxChecked(true);
		} else {
			setIsHeaderCheckboxChecked(false);
		}
	};

	useEffect(() => {
		const handleDocumentClick = () => {
			setIsPending(true);
			dispatch(actionGetEmployeesList(limit, pages)).then(() => {
				setIsPending(false);
			});
			setIsInputChange(false);
			resetPages();
		};

		if (isInputChange) {
			document.addEventListener('click', handleDocumentClick);

			return () => {
				document.removeEventListener('click', handleDocumentClick);
			};
		} else
			return () => {
				document.removeEventListener('click', handleDocumentClick);
			};
	}, [dispatch, isInputChange, limit, pages]);

	const resetPages = () => {
		setCurrentPage(1);
		setStartPage(1);
	};

	const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter') {
			setIsPending(true);
			dispatch(actionGetEmployeesList(limit, pages)).then(() => {
				setIsPending(false);
			});
			setIsInputChange(false);
			resetPages();
		}
	};

	const handleFilterInputChange = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const { name, value } = event.target;

		if (value === '') {
			const updatedInputValues = { ...userInputValues };
			delete updatedInputValues[name];
			dispatch(reducerClientsInputValues(updatedInputValues));
		} else {
			dispatch(
				reducerClientsInputValues({
					...userInputValues,
					[name]: value,
				})
			);
		}

		setIsInputChange(true);
	};

	const handleChange = (newLimit: number, newOffset: number) => {
		setIsPending(true);
		dispatch(actionGetEmployeesList(newLimit, newOffset)).then(() => {
			setIsPending(false);
		});
		localStorage.setItem('pageLimit', JSON.stringify(newLimit));
	};

	const selectChange = (event: any, name: string) => {
		const value = event.value;
		if (value === '') {
			const updatedInputValues = { ...userInputValues };
			delete updatedInputValues[name];
			dispatch(reducerClientsInputValues(updatedInputValues));
		} else {
			dispatch(
				reducerClientsInputValues({
					...userInputValues,
					[name]: name === 'fired' ? value === 'all' ? null : value === 'yes' : value,
				})
			)
		}
		setIsInputChange(true);
	};

	const handleChangeLimits = (option: any) => {
		handleChange(option.value, 0);
		setCurrentPage(1);
		setStartPage(1);
	};

  const handleCloseModal = useCallback(() => {
    dispatch(actionGetRoles());
    setIsOpenModal(false);
    setModalTitle("");
		// eslint-disable-next-line
  }, [dispatch]);
  
  const handleOpenModal = (name: any, claim: any, id: number) => {
    setIsOpenModal(true);
    setRoleClaims(claim);
    setModalTitle(name);
    setRoleId(id);
  };

	useEffect(()=> {
		setIsPending(true);
		dispatch(actionGetEmployeesFiltersLogin());
		dispatch(actionGetEmployeesFiltersRoles());
		dispatch(actionGetEmployeesList(limit, pages)).then(() => {
			dispatch(actionGetRoles());
			setIsPending(false);
		});



	// eslint-disable-next-line
	}, []);

	return (
		<>
			<div className='loader__wrapper'>
				{(isPending) && <Loader />}
			</div>
			<div
				className={clsx(
					JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
					isOpenSidebar &&
					'active__table',
					!isOpenSidebar && 'closed__table',
					'table'
				)}
			>
				<Toaster
					position='top-center'
					toastOptions={{
						duration: 5000,
					}}
				/>
				<div className='table__wrapper'>
					<table>
						<thead>
							<tr className='clients__list_head'>
              <th className='reports__checkbox_block reports__checkbox_block-small'>
										<input
											onChange={handleHeaderCheckboxChange}
											checked={isHeaderCheckboxChecked}
											type='checkbox'
										/>
								</th>
								<th>
									<div className='filter__number_block'>
										<input
											onChange={handleFilterInputChange}
											onKeyPress={handleKeyPress}
											placeholder=' '
											name='fullName'
											type='text'
										/>
										<label>ФИО</label>
									</div>
								</th>
                <th>
									<div className={clsx('filter__number_block')} >
										<Select
											options={optionsLogins}
											propsChange={(event: any) =>
												selectChange(event, "login")
											}
											placeholder='Логин'
											className='users__filter'
											name="login"
										/>
									</div>
								</th>

								<th>
									<div className={clsx('filter__number_block')} >
										<Select
											options={optionsRoles}
											propsChange={(event: any) =>
												selectChange(event, "role")
											}
											placeholder='Роль'
											className='users__filter'
											name="role"
										/>
									</div>
								</th>
                <th>
									<div className={clsx('filter__number_block')} >
										<Select
											options={booleanOptions}
											propsChange={(event: any) =>
												selectChange(event, "fired")
											}
											placeholder='Уволен'
											className='users__filter'
											name="fired"
										/>
									</div>
								</th>
                <th>
									<div className='filter__number_block'>
										<input
											name='claimsCol'
											placeholder=' '
											type='number'
											onChange={handleFilterInputChange}
											onKeyPress={handleKeyPress}
										/>
										<label>Кол-во клейм</label>
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							{data &&
								data.map((elem: any, index: number) => (
									<tr	key={index}>
                    <td>
												<input
													onChange={() => handleRowCheckboxChange(elem)}
													checked={
														(isCheckedRows && isCheckedRows[elem.id]) || false
													}
													className='relative__elem'
													type='checkbox'
												/>
										</td>
										<td className='error__td'>
											<span>{elem.fullName}</span>
										</td>
										<td className='error__td'>
											<span>{elem.login}</span>
										</td>
										<td className='error__td'>
											<span>{Object.values(elem.role)}</span>
										</td>
										<td>
                      <span>{elem.fired ? 'Да' : 'Нет'}</span>
                    </td>
											<td>{elem.claimsCol}</td>
											<td className='invisible__reports_cell' >
													<span
													 className='link__tr'
														onClick={() =>
															handleOpenModal(
																`${elem.fullName} (${Object.values(elem.role)})${elem.login || ''}`,
																[],
																elem.id
															)}></span>
										</td>
									</tr>
								))}
						</tbody>
					</table>
				</div>
				<div className='pagination'>
					<div className='pagination__count'>Всего: {usersCount}</div>
					<div className='pagination__str'>
						<span>Отображать строки</span>
						<LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
					</div>
					<Pagination
						setCurrentPage={setCurrentPage}
						setStartPage={setStartPage}
						handleChange={handleChange}
						currentPage={currentPage}
						count={usersCount}
						startPage={startPage}
						limit={actualLimit}
					/>
				</div>
			</div>
      {isOpenModal && (
        <RolesEmployeesModal
          onClose={handleCloseModal}
          claims={roleClaims}
          title={modalTitle}
          id={roleId}
        />
      )}
		</>
	);
};

export default TableAdminUsers;
